import React from "react";

import ThemedSelect from 'components/ThemedSelect';

import { useSettings } from "utils/settings";

import "bootstrap/dist/css/bootstrap.min.css";

const General = () => {
    const [settings, setSettings] = useSettings();

    const themes = [
        { value: 'light', label: 'Light' },
        { value: 'dark', label: 'Dark (in develop)' },
    ];

    const handleThemeChange = (selectedOption) => {
        const selectedTheme = selectedOption.value;

        setSettings(prev => ({ ...prev, theme: selectedTheme }));
        document.documentElement.setAttribute('data-theme', selectedTheme);
        // document.documentElement.setAttribute('data-bs-theme', selectedTheme);
    };

    return (
        <>
            <div className="mt-4">
                <div className="mb-3">
                    <label htmlFor="theme" className="form-label">Theme</label>
                    <ThemedSelect
                        name="theme"
                        options={themes}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={themes.find(option => option.value === settings.theme) || null}
                        onChange={handleThemeChange}
                        placeholder="Select theme..."
                    />
                </div>
            </div>
        </>
    );
};

export default General;
